/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';

// material
import {
    Group,
    Control,
} from '@insticator/insticator-ui'; // iui-material

// redux
import {useDispatch, useSelector} from "react-redux";

// components
import SectionGroupDescription
    from "../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";

// styles
import injectSheet from 'react-jss';
import styles from './formatsettings_styles';

// static
import {
    FORMAT,
    FORMAT_OPTIONS,
    SCHEDULE,
    SSP_ACCOUNT_UUIDS
} from "../consts";
import {updateReportForm} from "../../../../../state/slices/report";


/* ========== ~~~~~~~~~~ FREQUENCY FORM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {
    const formValues = useSelector((state) => state.report[props.uuid]);
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const isSspAccount = SSP_ACCOUNT_UUIDS.has(accountUUID);

    const dispatch = useDispatch();

    const handleOnChange = newValues => {
        dispatch(updateReportForm({...formValues, ...newValues}));
    }

    const handleFormatChange = val => {
        let scheduleSettings = {...formValues[SCHEDULE]}
        scheduleSettings[FORMAT] = val
        handleOnChange({[SCHEDULE]: scheduleSettings})
    }

    // If SSP account has an existing report with XLSX, force it to CSV
    useEffect(() => {
        if (isSspAccount && formValues && formValues[SCHEDULE] && formValues[SCHEDULE][FORMAT] === 'XLSX') {
            handleFormatChange('CSV');
        }
    }, [isSspAccount, formValues?.[SCHEDULE]?.[FORMAT]]);

    const formatOptions = isSspAccount
        ? FORMAT_OPTIONS.filter(o => o.value !== 'XLSX')
        : FORMAT_OPTIONS;

    return (
        <div className={props.classes.formatSettings}>
            <SectionGroup>
                <SectionGroupDescription
                    title='Format'
                    description={isSspAccount ? 'Excel format is not available for SSP accounts due to large data sizes.' : ''}
                />
                <Group name='format'>
                    {formatOptions.map(i => <Control
                        key={i.value}
                        text={i.title}
                        value={i.value}
                        selected={i.value === formValues[SCHEDULE][FORMAT]}
                        handleSelect={handleFormatChange}
                        variant={'secondary'}
                        addCheckWhenSelected={true}
                    />)}
                </Group>
            </SectionGroup>
        </div>
    )
});

